export default __webpack_public_path__ + "locales/vi/ConvertPasswordDialog.json?hash=c8d8e449b671ead86ec19b278e20f508";